/**
 * @generated SignedSource<<5eff4df4d2db4597c7a344f281366477>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useSyncCurrencyStore_regionalInfo$data = {
  readonly currency: string | null;
  readonly " $fragmentType": "useSyncCurrencyStore_regionalInfo";
};
export type useSyncCurrencyStore_regionalInfo$key = {
  readonly " $data"?: useSyncCurrencyStore_regionalInfo$data;
  readonly " $fragmentSpreads": FragmentRefs<"useSyncCurrencyStore_regionalInfo">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useSyncCurrencyStore_regionalInfo",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "currency",
      "storageKey": null
    }
  ],
  "type": "RegionalInfo",
  "abstractKey": null
};

(node as any).hash = "6d3b8ec5da6baeedc6096230eed60acc";

export default node;
